<script>
export default {
  name: 'SegmentationDefaultIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
    colorInternal: {
      type: String,
      default: '#fff',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original (copiado de export do Figma) colide quando o mesmo
    // ícone renderiza mais de uma vez na mesma página.
    clipId() {
      return `clip0_5192_145053_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="5.99998" y="6" width="11" height="11" :fill="color" />
    <path
      d="M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47077 4.17001C4.41077 4.57001 3.55077 5.81001 3.55077 6.94001V15.04C3.55077 15.85 4.08077 16.92 4.73077 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38077 16.25 7.25077 14.12 7.25077 11.5C7.25077 8.88001 9.38077 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z"
      :fill="color"
    />
    <g :clip-path="`url(#${clipId})`">
      <path
        d="M16.0698 14.093V9.90698C16.6232 9.67442 17 9.13023 17 8.51163C17 7.67907 16.3209 7 15.4884 7C14.8744 7 14.3256 7.37674 14.093 7.93023H9.90696C9.6744 7.37674 9.13022 7 8.51161 7C7.67905 7 6.99998 7.67907 6.99998 8.51163C6.99998 9.12558 7.37673 9.67442 7.93022 9.90698V14.093C7.37673 14.3256 6.99998 14.8698 6.99998 15.4884C6.99998 16.3209 7.67905 17 8.51161 17C9.12557 17 9.6744 16.6233 9.90696 16.0698H14.093C14.3256 16.6233 14.8698 17 15.4884 17C16.3209 17 17 16.3209 17 15.4884C17 14.8744 16.6232 14.3256 16.0698 14.093ZM15.3302 13.986C15.2791 13.9907 15.2325 14 15.1814 14.0093C15.0558 14.0326 14.9349 14.0744 14.8186 14.1349C14.7907 14.1488 14.7628 14.1628 14.7349 14.1814C14.5023 14.3116 14.3116 14.5023 14.1814 14.7349C14.1628 14.7628 14.1488 14.7907 14.1349 14.8186C14.0744 14.9349 14.0325 15.0558 14.0093 15.1814C14 15.2326 13.9907 15.2791 13.986 15.3302C13.9814 15.3442 13.9814 15.3581 13.9814 15.3721H10.0186C10.0093 15.2558 9.98603 15.1442 9.95347 15.0372C9.94417 15 9.93022 14.9581 9.91161 14.9209C9.89766 14.8884 9.88371 14.8558 9.8651 14.8186C9.85115 14.7907 9.83719 14.7628 9.81859 14.7349C9.68836 14.5023 9.49766 14.3116 9.2651 14.1814C9.23719 14.1628 9.20929 14.1488 9.18138 14.1349C9.14417 14.1163 9.11161 14.1023 9.07905 14.0884C9.04185 14.0698 8.99998 14.0558 8.96278 14.0465C8.8558 14.014 8.74417 13.9907 8.62789 13.9814V10.0186C8.74882 10.0093 8.86045 9.98605 8.97208 9.94884C9.01394 9.93954 9.06045 9.92093 9.10231 9.90233C9.12557 9.89302 9.15347 9.87907 9.18138 9.86512C9.20929 9.85116 9.23719 9.83721 9.2651 9.8186C9.49766 9.68837 9.68836 9.49767 9.81859 9.26512C9.83719 9.23721 9.85115 9.2093 9.8651 9.1814C9.87905 9.15349 9.89301 9.12558 9.90231 9.10233C9.92091 9.06047 9.93952 9.01395 9.94882 8.97209C9.98603 8.86047 10.0093 8.74884 10.0186 8.62791H13.9814C13.9907 8.75349 14.0139 8.86977 14.0558 8.98605C14.0651 9.02326 14.0791 9.06512 14.0977 9.10233C14.107 9.13023 14.1209 9.15349 14.1349 9.1814C14.1488 9.2093 14.1628 9.23721 14.1814 9.26512C14.3116 9.49767 14.5023 9.68837 14.7349 9.8186C14.7628 9.83721 14.7907 9.85116 14.8186 9.86512C14.8465 9.87907 14.8698 9.89302 14.8977 9.90233C14.9349 9.92093 14.9767 9.93488 15.0139 9.94419C15.1302 9.98605 15.2465 10.0093 15.3721 10.0186V13.9814C15.3721 13.9814 15.3442 13.9814 15.3302 13.986Z"
        :fill="colorInternal"
      />
    </g>
    <defs>
      <clipPath :id="clipId">
        <rect
          width="10"
          height="10"
          :fill="colorInternal"
          transform="translate(6.99998 7)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
